import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import "../Styles/NotFound.css";

function NotFound() {
  return (
    <div className="notfound-page">
      <Navbar />

      <section className="notfound-section">
        <div className="container">
          <div className="notfound-content">
            <span className="notfound-code">404</span>
            <h1>Page Not Found</h1>
            <p>The page you're looking for doesn't exist or has been moved.</p>
            <Link to="/" className="btn-primary">
              <FontAwesomeIcon icon={faHome} /> Back to Home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default NotFound;
